module.exports = __webpack_public_path__ + "img/de.6846d6a6.svg";